import WorkflowList from '@/features/Workflow/WorkflowPage';

const WorkflowPage = () => {
  return <WorkflowList />;
};

export default WorkflowPage;
